module.exports = __webpack_public_path__ + "img/bny-detail-7.afd38262.png";